import {
  mutationOptions,
  useMutation,
  type UseMutationOptions,
} from '@tanstack/react-query';

import {
  type ValidateLabelingPositionConsistencyPayload,
  type ValidateLabelingPositionConsistencyResponse,
} from './types';
import { validateLabelingPositionConsistency } from './validateLabelingPositionConsistency';

export const getValidateLabelingPositionConsistencyMutationOptions = ({
  options,
}: {
  options?: Omit<UseMutationOptions, 'mutationFn'>;
}): UseMutationOptions => {
  return mutationOptions({
    mutationFn: async (
      queryParameters: ValidateLabelingPositionConsistencyPayload,
    ) => validateLabelingPositionConsistency(queryParameters),
    ...options,
  });
};

/**
 * Custom useMutation hook to validate the consistency of label positions.
 * @param options - Mutation options
 * @returns The validation result.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/labeling_position_consistency_labeling_position_consistency_get
 */
export const useMutationValidateLabelingPositionConsistency = (
  options?: Omit<
    UseMutationOptions<ValidateLabelingPositionConsistencyResponse>,
    'mutationFn'
  >,
) => {
  return useMutation({
    ...getValidateLabelingPositionConsistencyMutationOptions({
      options,
    }),
  });
};
